import axios from 'axios'
import { Message } from 'element-ui'
import Router from '@/router/index.ts'
import urlBase from '@/utils/urlBase'

import settings from '../settings'
import Vue from 'vue'
const that: any = new Vue()
const mockOn = false // 引入要使用的组件
console.log('urlBase: ', urlBase)
const service = axios.create({ baseURL: !mockOn ? urlBase.eduBaseUrl : `http://${settings.ip}:${settings.mockServerPort}`, withCredentials: true })
// Response interceptors
service.interceptors.response.use(
  (response) => {
    const res = response.data
    if (res.error.returnCode === 777) { // 无角色
      Message({ message: res.error.returnMessage || 'Error', type: 'error', duration: 5 * 1000 })
      if (document.referrer) {
        setTimeout(() => {
          window.close()
        }, 2000)
        return Promise.reject(new Error(res.error.returnMessage || 'Error'))
      }
    } else if (res.error.returnCode === 10000) {
      Router.push('/login')
    } else if (res.error.returnCode === 901) { // 全局冲突
      that.$popup({
        show: true,
        returnData: res.data
      })
      return Promise.reject(new Error(res.error.returnMessage || 'Error'))
    } else if (res.error.returnCode !== 0 && res.error.returnCode !== 901) { // 其他报错
      Message({ message: res.error.returnMessage || 'Error', type: 'error', duration: 5 * 1000 })
      return response.data
    } else { // 成功
      return response.data.data
    }
  },
  (error) => { Message({ message: error.message, type: 'error', duration: 5 * 1000 }); return Promise.reject(error) }
)

export default service
